import axios from "axios";

const instance = axios.create({
  // baseURL:
  //   process.env.NODE_ENV === "development"
  //     ? `https://coreapidevjaguar.withhalal.com/api/v1`
  //     : `https://coreapiprodmelon.withhalal.com/api/v1`,
  baseURL: `https://coreapidevjaguar.withhalal.com/api/v1`,
  headers: {},
});

export default instance;
